<cdk-virtual-scroll-viewport (scroll)="onTableScroll($event)" class="list" itemSize="35">
  <table [dataSource]="this" [multiTemplateDataRows]="true" class="table" mat-table>
    <ng-container matColumnDef="descriptor">
      <th *matHeaderCellDef class="tableBg" mat-header-cell> No.</th>
      <td *matCellDef="let element" mat-cell> {{element.descriptor}} </td>
    </ng-container>

    <ng-container matColumnDef="motive">
      <th *matHeaderCellDef class="tableBg" mat-header-cell>{{'lang.globals.medias'|translate}}</th>
      <td *matCellDef="let element" mat-cell class="d-flex align-items-center">
        <sb-comp-medium [customHeight]="'100%'" [customWidth]="'250px'" [hoverPlacement]="'top'" [hoverPreview]="true"
                        [medium]="element?.booking?.medium" [showFullOnClick]="true" [still]="true"
                        [thumbnailSize]="'XS'">
        </sb-comp-medium>
        <sb-comp-name-wrapper classes="ml-2">
          <span firstLine>{{element?.booking?.medium?.name}}</span>
        </sb-comp-name-wrapper>
      </td>
    </ng-container>

    <ng-container matColumnDef="templateDataset">
      <th *matHeaderCellDef class="tableBg" mat-header-cell>{{'lang.globals.templateDataset'|translate}}</th>
      <td *matCellDef="let element" mat-cell> {{element?.usedTemplateEntry?.name}} </td>
    </ng-container>

    <ng-container matColumnDef="start">
      <th *matHeaderCellDef class="tableBg" mat-header-cell>{{'lang.globals.playoutsTime'|translate}}</th>
      <td *matCellDef="let element" mat-cell> {{util.dateToDateTimeString(element?.start?.value, true)}} </td>
    </ng-container>

    <ng-container matColumnDef="playbacktime">
      <th *matHeaderCellDef class="tableBg" mat-header-cell>{{'lang.globals.playoutDuration'|translate}}</th>
      <td *matCellDef="let element" mat-cell> {{element.playbacktime}} s</td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>

    <!-- cdkVirtualScrollViewport uses transform: translateY to correct for all elements that are removed.
    We will use a placeholder row in the table instead because the translate causes problems with the sticky header -->
    <tr *matRowDef="let row; let index = index; columns: []; when: placeholderWhen" [style.height.px]="placeholderHeight"
        mat-row></tr>

    <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
  </table>
  <div class="spinnerWrapper">
    <ng-container *ngIf="loading">
      <sb-icon [animationOptions]="{autoplay: true, loop:true}" class="loadingSpinnerSVG" icon="loadingBlockAnimation"
               style="font-size: 2rem"></sb-icon>
      <span>{{'lang.globals.pleaseWait' | translate}}</span>
    </ng-container>
  </div>
</cdk-virtual-scroll-viewport>
